var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"white-container"},[_c('tabs-list',{attrs:{"tabs":_vm.tabs},on:{"changeCurrentTab":function($event){return _vm.changeCurrentTab($event)}}}),_c(_vm.tabs.list[_vm.tabs.current].component,{tag:"component",on:{"changeCurrentTab":function($event){return _vm.changeCurrentTab($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }